import React from "react";
import { connect } from "react-redux";
import UserProfile from "./UserProfile";
import ManageUser from "./ManageUser/ManageUser";
import ManageHipaaUser from "./ManageHipaaUser/ManageHipaaUser";
import SensitiveDataActivityLog from "./SensitiveDataActivityLog/SensitiveDataActivityLog";
import SupportTickets from "./SupportTickets";
import PlgSupportPage from "./PlgSupportPage";
import { Message } from "semantic-ui-react";
import utilFunc from "../../../util_funs";
import Billing from '../../Billing/Billing';
import '../../Billing/billing.css';
import api from "../../../api";
import CreateTicket from "../../../components/Ticket/CreateTicket"
import { selectIsPLGAccount } from "../../../store/userSelectors";
import { SETTINGS_TAB_CONFIG } from "../../../config/menuConfig";

import {
  setPageTitle,
  toggleNavigation,
  setBreadCrum,
  toggleBreadcrum,
  clearMessage
} from "../../../store/Page";
import { Link, withRouter } from "react-router-dom";
import Integration from "./Integration/Integration";
import ApiInstruction from "./ApiInstruction";
const queryString = require("query-string");

class Settings extends React.Component {
  constructor(props) {
    super(props);
    const params = queryString.parse(props.location?.search || "");
    const isBillingTab = params.tab === "billing";
    this.state = {
      currentTab: "profile",
      toggleCreateTicketBtn: false,
      addUserBt: false,
      userToaster: false,
      userToasterMsg: "",
      userToasterColor: "", 
      profileTab: isBillingTab ? "" : "active",
      billing: isBillingTab ? "active" : "",
      billingRefreshKey: isBillingTab ? 1 : 0,
      userTab: "",
      sensitiveTab: "",
      supportTab: "",
      hipaaUserTab: "",
      ticketSuccessMessage: "",
      addHipaaUserBt:"",
      integrationTab: "",
      apiInstructionTab: "",
      profileData:{},
      createTicketTab:""

    };
  }

  componentDidUpdate(prevProps) {
    const locationChanged =
      prevProps.location?.pathname !== this.props.location?.pathname
      || prevProps.location?.search !== this.props.location?.search;

    if (locationChanged) {
      this.applyTabFromLocation(this.props.location);
    }
  }

  applyTabFromLocation = (location) => {
    const params = queryString.parse(location?.search || "");
    if (!params?.tab) {
      return;
    }

    if (params.tab === "support") {
      if (this.props.PageMessage) {
        this.setState(
          { ticketSuccessMessage: this.props.PageMessage },
          () => {
            utilFunc.scrollTop(800);
            setTimeout(() => {
              this.setState({ ticketSuccessMessage: false });
              this.props.clearMessage();
            }, 10000);
          }
        );
      }
      this.toggleTab("support");
      return;
    }

    const tabMap = {
      manageuser: "user",
      profile: "profile",
      billing: "billing",
      sensitive: "sensitive",
      hipaauser: "hipaauser",
      integration: "integration",
      "api-instructions": "apiInstruction",
      createTicket: "createTicket",
    };

    const toggleKey = tabMap[params.tab];
    if (toggleKey) {
      this.toggleTab(toggleKey);
    }
  };

  componentDidMount() {
    this.gtUserProf();
    const {
      setPageTitle,
      toggleNavigation,
      location,
      PageMessage,
      setBreadCrum,
      toggleBreadcrum,
      clearMessage
    } = this.props;
    setPageTitle({ title: "Settings", subHeaderTitle: "Settings" });
    setBreadCrum({ breadcrum: null });

    toggleNavigation({ toggle: false });
    toggleBreadcrum({ toggle: false });
    this.applyTabFromLocation(location);
  }
  gtUserProf=()=>{
    api.user
      .getProfile()
      .then((resp) => {
        if (resp.data) {
         this.setState({profileData:resp.data.data});
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ loading: false });
      });
  }

  getClassName = (tab, isNav = true) => {
    let parentClass = "nav-link";
    let childClass = "tab-pane";

    if (isNav) {
      if (this.state.currentTab === tab) {
        parentClass = parentClass + " active";
      }

      return parentClass;
    } else {
      if (this.state.currentTab === tab) childClass = childClass + " active";
      return childClass;
    }
  };

  toggleTab = (tab) => {
    const params = queryString.parse(this.props.location.search);
    if (tab === "profile") {

      this.setState({
        addUserBt: false,
        profileTab: "active",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:""
      });
    
      if(params.tab !='profile'){
      this.props.history.push('settings?tab=profile');
      }

    }else if (tab === "billing") {
      this.setState((prevState) => ({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"active",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:"",
        billingRefreshKey: prevState.billingRefreshKey + 1,
      }));
      if(params.tab !='billing'){
        this.props.history.push('settings?tab=billing');
        }
      
    } else if (tab === "user") {
      this.setState({
        addUserBt: true,
        profileTab: "",
        userTab: "active",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:""
      });
  
      if(params.tab !=='manageuser'){
      this.props.history.push('settings?tab=manageuser');
      }
      
    } else if (tab === "sensitive") {
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "active",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:""
      });
      if(params.tab !='sensitive'){
        this.props.history.push('settings?tab=sensitive');
        }
   
    } else if (tab === "support") {
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "active",
        hipaaUserTab:"",
        toggleCreateTicketBtn: true,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:""
      });
      if(params.tab !='support'){
        this.props.history.push('settings?tab=support');
        }
    } else if (tab === "hipaauser") {
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"active",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:true,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:""
      });
      if(params.tab !='hipaauser'){
        this.props.history.push('settings?tab=hipaauser');
        }
      
    }else if(tab === "integration"){
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "active",
        apiInstructionTab: "",
        createTicketTab:""
      });
      if(params.tab !='integration'){
        this.props.history.push('settings?tab=integration');
      }
    }else if(tab === "apiInstruction"){
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: false,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "active",
        createTicketTab:""
      });
      if(params.tab !='api-instructions'){
        this.props.history.push('settings?tab=api-instructions');
      }
    }else if(tab === "createTicket"){
      this.setState({
        addUserBt: false,
        profileTab: "",
        userTab: "",
        sensitiveTab: "",
        supportTab: "",
        hipaaUserTab:"",
        toggleCreateTicketBtn: true,
        addHipaaUserBt:false,
        billing:"",
        integrationTab: "",
        apiInstructionTab: "",
        createTicketTab:"active"
      });
      if(params.tab !='createTicket'){
        this.props.history.push('settings?tab=createTicket');
      }
    }
  };

  showToaster = (color, msg) => {
    this.setState({
      userToaster: true,
      userToasterMsg: msg,
      userToasterColor: color,
    });
    setTimeout(
      function () {
        this.setState({ userToaster: false });
      }.bind(this),
      3000
    );
  };

  renderSettingsTabs = () => {
    const { user, isPLG } = this.props;
    const settingsMenu = (user.leftBarAccessList || []).find(
      (item) => item.key === "settings"
    );
    const children = settingsMenu ? settingsMenu.childElement || [] : [];

    return children.map((child) => {
      const matchKey = Object.keys(SETTINGS_TAB_CONFIG).find(
        (k) => child.component && child.component.includes(k)
      );

      // Unknown tab — stable hidden placeholder so array indices never shift
      if (!matchKey) {
        return <li key={child.component || child.title} style={{ display: "none" }} aria-hidden="true" />;
      }

      const cfg = SETTINGS_TAB_CONFIG[matchKey];

      // Apply all conditions from menuConfig
      const skip =
        (cfg.skipIfPLG && isPLG) ||
        (cfg.skipIfSubaccount && !!user.user_subaccount_id);

      const visible =
        !skip &&
        (cfg.module ? user.totalAvailableModules.includes(cfg.module) : true);

      return (
        <li
          key={matchKey}
          style={{ display: visible ? "" : "none" }}
          className="nav-item"
        >
          <a
            className={"nav-link " + this.state[cfg.stateKey]}
            data-toggle="tab"
            role="tab"
            style={{ cursor: "pointer" }}
            onClick={() => this.toggleTab(cfg.toggleKey)}
          >
            {child.title.trim()}
          </a>
        </li>
      );
    });
  };

  render() {
    const params = queryString.parse(this.props.location.search);
    const supportListKey = params.refresh ? `support-${params.refresh}` : "support-default";

    return (
      <div className="kt-container kt-body  kt-grid kt-grid--ver" id="kt_body">
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
          <div className="kt-content kt-grid__item kt-grid__item--fluid">
            <div className="yr-body-p">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="kt-portlet kt-portlet--tabs yr-mt-20 shadow-none">
                    <div className="kt-portlet__head">
                      <div className="kt-portlet__head-toolbar">
                        <ul
                          className="nav nav-tabs nav-tabs-line nav-tabs-line-success nav-tabs-line-3x"
                          role="tablist"
                        >
                          {this.renderSettingsTabs()}
                        </ul>
                      </div>
                    </div>

                    <div className="kt-portlet__body yr-pd0-lr">
                      <div className="tab-content">
                        <div
                          className={"tab-pane " + this.state.profileTab}
                          id="kt_portlet_base_demo_1_1_tab_content"
                          role="tabpanel"
                        >
                          {this.state.profileData && <UserProfile data={this.state.profileData} />}
                        </div>
                        {/* {!this.props.user.user_subaccount_id && ( */}
                          <div
                            className={
                              "tab-pane yr-manageUser-table " +
                              this.state.userTab
                            }
                            id="kt_portlet_base_demo_1_2_tab_content"
                            role="tabpanel"
                          >
                            <Message
                              color={
                                this.state.userToasterColor
                                  ? this.state.userToasterColor
                                  : "green"
                              }
                              style={{
                                display: this.state.userToaster
                                  ? "block"
                                  : "none",
                                marginTop: 30,
                              }}
                            >
                              {this.state.userToasterMsg}
                            </Message>
                            <ManageUser
                              ref={(child) => {
                                this.child = child;
                              }}
                              showUserToaster={this.showToaster}
                              sessionUser={this.props.user}
                              profiledata={this.state.profileData}
                            />
                          </div>
                        {/* )} */}
                        {!this.props.user.user_subaccount_id && (
                          <div
                            className={
                              "tab-pane yr-manageUser-table " +
                              this.state.hipaaUserTab
                            }
                            id="kt_portlet_base_demo_1_2_tab_content"
                            role="tabpanel"
                          >
                            <Message
                              color={
                                this.state.userToasterColor
                                  ? this.state.userToasterColor
                                  : "green"
                              }
                              style={{
                                display: this.state.userToaster
                                  ? "block"
                                  : "none",
                                marginTop: 30,
                              }}
                            >
                              {this.state.userToasterMsg}
                            </Message>
                            <ManageHipaaUser
                              ref={(childHipaa) => {
                                this.childHipaa = childHipaa;
                              }}
                              showUserToaster={this.showToaster}
                              sessionUser={this.props.user}
                              profiledata={this.state.profileData}

                            />
                          </div>
                        )}
                        <div
                           className={
                            "tab-pane yr-manageUser-table " +
                            this.state.sensitiveTab
                          }
                          id="kt_portlet_base_demo_1_3_tab_content"
                          role="tabpanel"
                        >
                          <SensitiveDataActivityLog user = {this.props.user} />
                        </div>
                        <div
                          className={
                            "tab-pane yr-manageUser-table " +
                            this.state.supportTab
                          }
                          id="kt_portlet_base_demo_1_4_tab_content"
                          role="tabpanel"
                        >
                          {this.props.isPLG ? (
                            <PlgSupportPage
                              supportEmail={this.props.user?.plg_mail_id}
                            />
                          ) : (
                            <>
                              {this.state.ticketSuccessMessage && (
                                <Message color="green">
                                  {typeof this.state.ticketSuccessMessage === "string"
                                    ? this.state.ticketSuccessMessage
                                    : this.state.ticketSuccessMessage.text}
                                </Message>
                              )}
                              <SupportTickets
                                key={supportListKey}
                                history={this.props.history}
                              />
                            </>
                          )}
                        </div>
						            <div
                          className={
                            "tab-pane yr-manageUser-table " +
                            this.state.billing
                          }
                          id="kt_portlet_base_demo_1_5_tab_content"
                          role="tabpanel"
                        >
						            <Billing history={this.props.history} location={this.props.location} profiledata={this.state.profileData} user = { this.props.user } isActive={this.state.billing === 'active'} billingRefreshKey={this.state.billingRefreshKey}/>
                        </div>
                        {!this.props.isPLG && (
                          <div
                            className={"tab-pane " + this.state.integrationTab}
                            id="kt_portlet_base_demo_1_1_tab_content"
                            role="tabpanel"
                          >
                            <Integration />
                          </div>
                        )}
                        {!this.props.isPLG && (
                          <div
                            className={"tab-pane " + this.state.apiInstructionTab}
                            id="kt_portlet_base_demo_1_1_tab_content"
                            role="tabpanel"
                          >
                            <ApiInstruction />
                          </div>
                        )}
                        <div
                          className={"tab-pane " + this.state.createTicketTab}
                          id="kt_portlet_base_demo_1_1_tab_content"
                          role="tabpanel"
                        >
                          <CreateTicket history={this.props.history} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    PageMessage: state.page.message,
    user: state.user.company,
    isPLG: selectIsPLGAccount(state),  // Get PLG status directly!
  };
};
export default withRouter(connect(mapStateToProps, {
  setPageTitle,
  toggleNavigation,
  setBreadCrum,
  toggleBreadcrum,
  clearMessage
})(Settings));
